declare global {
    interface Window {
        __BRR_ENV__?: Record<string, string | undefined>;
    }
}

// Resolves config from runtime injection first (env-config.js written by the
// prod container entrypoint), then falls back to Vite's build-time inlining so
// one built image can serve any environment without a rebuild.
export function readEnv(key: string): string | undefined {
    const runtimeValue = window.__BRR_ENV__?.[key];
    if (runtimeValue) {
        return runtimeValue;
    }
    return (import.meta.env as Record<string, string | undefined>)[key];
}
